import { Injectable, Injector } from '@angular/core';
import { Params, Router } from '@angular/router';
import { RepositoryService } from '../../smoothr-web-app-core/services/repository/repository.service';

export const NAVIGATIONURLS = {
	tos: () => 'tos',
	faq: () => 'faq',
	home: () => 'home',
	menu: () => 'menu',
	order: () => 'order',
	privacy: () => 'privacy',
	loyalty: () => 'loyalty',
	privacyApp: () => 'privacy-app',
	cookie: () => 'cookie',
	myOrders: () => 'my-orders',
	impressum: () => 'impressum',
	maintenance: () => 'maintenance',
	selectCategory: () => 'select-category',
};

@Injectable({
	providedIn: 'root',
})
export class NavigationService {
	constructor(
		private router: Router,
		private injector: Injector
	) {}

	private isGermanVenue(): boolean {
		const venue = this.injector.get(RepositoryService)._venue;
		console.log({
			country: venue?.country,
		});
		return (venue?.country ?? '').toLowerCase() === 'de';
	}

	async menu() {
		await this.router.navigateByUrl(NAVIGATIONURLS.menu());
	}

	async home() {
		await this.router.navigateByUrl(NAVIGATIONURLS.home());
	}

	async homeWithTable(venueId: string, tableNumber: string) {
		console.log('homeWithTable()', {
			venueId,
			tableNumber,
		});
		await this.router.navigate([venueId, tableNumber]);
	}

	async order(largeScreen = false) {
		return this.router.navigateByUrl(largeScreen ? NAVIGATIONURLS.menu() : NAVIGATIONURLS.order());
	}

	async imprint() {
		// await this.router.navigateByUrl(NAVIGATIONURLS.impressum());
		const url = this.isGermanVenue() ? 'https://topgolfoberhausen.com/impressum/' : 'https://topgolfwien.com/impressum/';
		window.open(url, '_blank');
	}

	async maintenance() {
		await this.router.navigateByUrl(NAVIGATIONURLS.maintenance(), {
			skipLocationChange: true,
			replaceUrl: false,
		});
	}

	async faq() {
		await this.router.navigateByUrl(NAVIGATIONURLS.faq());
	}

	async tos() {
		await this.router.navigateByUrl(NAVIGATIONURLS.tos());
	}

	async myOrders() {
		await this.router.navigateByUrl(NAVIGATIONURLS.myOrders());
	}

	async cookie() {
		await this.router.navigateByUrl(NAVIGATIONURLS.cookie());
	}

	async privacy() {
		// await this.router.navigateByUrl(NAVIGATIONURLS.privacy());
		const url = this.isGermanVenue() ? 'https://topgolfoberhausen.com/datenschutz/' : 'https://topgolfwien.com/datenschutz/';
		window.open(url, '_blank');
	}

	async navigateToUrl(url: string) {
		await this.router.navigateByUrl(url);
	}

	async navigateToUrlWithParams(url: string, queryParams: Params) {
		await this.router.navigate([url], {
			queryParams,
			replaceUrl: true,
		});
	}

	async navigateSelectedCategory(categoryId?: string) {
		let queryParams = {};
		if (categoryId) {
			queryParams = {
				categoryId,
			};
		}
		await this.router.navigate([NAVIGATIONURLS.selectCategory()], {
			queryParams,
			replaceUrl: true,
		});
	}

	async loyalty() {
		await this.router.navigateByUrl(NAVIGATIONURLS.loyalty());
	}
}
